import { render, staticRenderFns } from "./node-element-social-sharing.vue?vue&type=template&id=1c832971&scoped=true"
import script from "./node-element-social-sharing.vue?vue&type=script&lang=js"
export * from "./node-element-social-sharing.vue?vue&type=script&lang=js"
import style0 from "./node-element-social-sharing.vue?vue&type=style&index=0&id=1c832971&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c832971",
  null
  
)

export default component.exports